module.exports = __webpack_public_path__ + "static/media/zone1.64fad5f0.png";